import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Modal, SecondaryButton } from '../../components';
import css from './ModalBlockedUser.css';

const ModalBlockedUser = ({ isOpen, onClose, onManageDisableScrolling }) => {
  return (
    <Modal
      id="ModalBlockedUser"
      isOpen={isOpen}
      onClose={onClose}
      onManageDisableScrolling={onManageDisableScrolling}
      usePortal
    >
      <div className={css.content}>
        <h2 className={css.title}>
          <FormattedMessage id="ModalBlockedUser.title" />
        </h2>
        <p className={css.description}>
          <FormattedMessage id="ModalBlockedUser.description" />
        </p>
        <div className={css.contactSupport}>
          <FormattedMessage
            id="ModalBlockedUser.contactSupport"
            values={{
              email: (
                <a href="mailto:hello@freedomly.io" className={css.supportLink}>
                  hello@freedomly.io
                </a>
              ),
            }}
          />
        </div>
        <div className={css.buttons}>
          <SecondaryButton onClick={onClose}>
            <FormattedMessage id="ModalBlockedUser.close" />
          </SecondaryButton>
        </div>
      </div>
    </Modal>
  );
};

export default ModalBlockedUser;
